import {
  FETCH_AVAILABILITY,
  APPLY_FILTER,
  FILLING_TRAINS_QUERY_DATA,
  SEARCH_TRAINS,
  SET_SEARCH_DATA,
  SORT_SELECTED,
  ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE,
  ACTION_INIT_RAILS_LISTING_FILTERS,
  ACTION_FETCH_ALTERNATE_AVAILIBILITY,
  FETCH_AVAILABILITY_SET_LOADER,
  FETCH_AVAILABILITY_SET_ERROR,
  ACTION_SET_CONFIRM_OPTIONS,
  FETCH_AVAILABILITY_REMOVE_ERROR,
  CONFIRMATION_PROBABILITY,
  DEFAULT_SORT_SELECTED,
  CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY,
  SET_BIZ_USER_INFO,
  MYBIZ_REQUISITION_FLOW,
} from './ListingActionTypes';

import { SortField } from '../../../constants/SortFields';
import { sortComparators } from '../../../utils/trainUtils';
import { cloneDeep } from 'lodash'

const initRailsFilterObject = {
  quickFilter: {
    heading: 'Quick Filters',
    filterTypes: {},
  },
  journeyClassFilter: {
    heading: 'Journey Class',
    filterTypes: {},
  },
  trainTypeFilter: {
    heading: 'Train Type',
    filterTypes: {},
  },
  departureTimeFilter: {
    heading: '',
    filterTypes: {
      nightFilter: {
        noOfTrains: 0,
        key: 'night',
        heading: 'Night',
        subHeading: '12 AM to 6 AM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.departureTime.split(':')[0]); //train.departureDateAndTime.getHours();
          return (hours >= 0 && hours < 6);
        },
      },
      morningFilter: {
        noOfTrains: 0,
        key: 'morning',
        heading: 'Morning',
        subHeading: '6 AM to 12 PM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.departureTime.split(':')[0]); //train.departureDateAndTime.getHours();
          return (hours >= 6 && hours < 12);
        },
      },
      afternoonFilter: {
        noOfTrains: 0,
        heading: 'Afternoon',
        key: 'afternoon',
        subHeading: '12 PM to 6 PM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.departureTime.split(':')[0]); //train.departureDateAndTime.getHours();
          return (hours >= 12 && hours < 18);
        },
      },
      eveningFilter: {
        noOfTrains: 0,
        heading: 'Evening',
        key: 'evening',
        subHeading: '6 PM to 12 AM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.departureTime.split(':')[0]); //train.departureDateAndTime.getHours();
          return (hours >= 18 && hours <= 23);
        },
      },
    },
  },
  arrivalTimeFilter: {
    heading: '',
    filterTypes: {
      nightFilter: {
        noOfTrains: 0,
        heading: 'Night',
        key: 'night',
        subHeading: '12 AM to 6 AM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.arrivalTime.split(':')[0]);//train.arrivalDateAndTime.getHours();
          return (hours >= 0 && hours < 6);
        },
      },
      morningFilter: {
        noOfTrains: 0,
        heading: 'Morning',
        key: 'morning',
        subHeading: '6 AM to 12 PM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.arrivalTime.split(':')[0]);//train.arrivalDateAndTime.getHours();
          return (hours >= 6 && hours < 12);
        },
      },
      afternoonFilter: {
        noOfTrains: 0,
        heading: 'Afternoon',
        key: 'afternoon',
        subHeading: '12 PM to 6 PM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.arrivalTime.split(':')[0]);//train.arrivalDateAndTime.getHours();
          return (hours >= 12 && hours < 18);
        },
      },
      eveningFilter: {
        noOfTrains: 0,
        heading: 'Evening',
        key: 'evening',
        subHeading: '6 PM to 12 AM',
        selected: false,
        condition: (train) => {
          const hours = Number(train.arrivalTime.split(':')[0]);//train.arrivalDateAndTime.getHours();
          return (hours >= 18 && hours <= 23);
        },
      },
    },
  },
  fromStnFilter: {
    heading: '',
    filterTypes: {},
  },
  toStnFilter: {
    heading: '',
    filterTypes: {},
  },
};

const initActiveFilter = {
  quickFilter: [],
  journeyClassFilter: [],
  arrivalTimeFilter: [],
  departureTimeFilter: [],
  trainTypeFilter: [],
  startStationsFilter: [],
  endStationsFilter: [],
  ticketTypeFilter:[]
}

const INITIAL_STATE = {
  selectedKey: '',
  railSearchData: [],
  defaultRailSearchData: [],
  activefillter: cloneDeep(initActiveFilter),
  selectedSortField: SortField.availibility,
  isAscOrder: true,
  quotaList: [],
  fromStationNode: {},
  toStationNode: {},
  doj: '',
  classNode: {},
  filterObject: initRailsFilterObject,
  initFilterObject: {},
  confirmedOptionsOfRails: [],
  bookingFor: { name: '', email: '', mobile: '', gender: '' },
  requisitionId: null,
  myBizRequisitionFlow: null,
  errorMessage: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_SEARCH_DATA: {
      const { fromStationNode, toStationNode, doj, classNode, requisitionId } = action.data;
      return {
        ...state,
        fromStationNode,
        toStationNode,
        classNode,
        doj,
        requisitionId,
      };
    }
    case SEARCH_TRAINS: {
      const { railSearchData, errorMessage } = action.payload;
      if (errorMessage) {
        return { ...state, railSearchData: [], defaultRailSearchData: [], errorMessage };
      }
      railSearchData.forEach((element) => {
        element.cnfOptions = { loading: true, text: null };
      });
      // const { selectedSortField, isAscOrder } = state;
      // const sortedRailData = railSearchData.sort(sortComparators(selectedSortField, isAscOrder));
      return { ...state,defaultRailSearchData:railSearchData, railSearchData: railSearchData, errorMessage: null, ...action.payload };
    }
    case SET_BIZ_USER_INFO: {
      return {
        ...state,
        bookingFor: {
          ...state.bookingFor,
          ...action.data,
        },
      }
    }

    case MYBIZ_REQUISITION_FLOW: {
      return { ...state, myBizRequisitionFlow: {
        ...state.myBizRequisitionFlow,
        ...action.payload
       } };
    }
    case ACTION_INIT_RAILS_LISTING_FILTERS: {
      const { filterObject } = action.data;
      return {
        ...state,
        filterObject,
        initFilterObject: filterObject,
        activefillter: cloneDeep(initActiveFilter),
      };
    }

    case FILLING_TRAINS_QUERY_DATA: {
      return { ...state, railSearchData: [] };
    }

    case SORT_SELECTED: {
      const { selectedSortField, isAscOrder } = action.payload;
      const sortedRailData = [...state.railSearchData]
        .sort(sortComparators(selectedSortField, isAscOrder));
      return { ...state, railSearchData: sortedRailData, ...action.payload };
    }

    case FETCH_AVAILABILITY_SET_ERROR: {
      const { selectedKey, trainNumber, className, quota, errorMessage } = action.payload;
      const newRailSearchData = changeTBSAvailability(state.railSearchData, { errorMessage, showLoader: false }, trainNumber, className, quota, true);
      return {
        ...state,
        selectedKey,
        railSearchData: newRailSearchData,
      };
    }

    case FETCH_AVAILABILITY_REMOVE_ERROR: {
      const { trainNumber, className, quota } = action.payload;
      const newRailSearchData = changeTBSAvailability(state.railSearchData, { errorMessage: '' }, trainNumber, className, quota, true);
      return {
        ...state,
        railSearchData: newRailSearchData,
      };
    }

    case FETCH_AVAILABILITY_SET_LOADER: {
      const { trainNumber, className, quota } = action.payload;
      const newRailSearchData = changeTBSAvailability(state.railSearchData, { showLoader: true }, trainNumber, className, quota, true);
      return {
        ...state,
        railSearchData: newRailSearchData,
      };
    }

    case FETCH_AVAILABILITY: {
      const { availabilityResponse, tbsAvailability, trainNumber, selectedKey, className, quota } = action.payload;
      const newRailSearchData = changeTBSAvailability(state.railSearchData, { ...tbsAvailability, showLoader: false }, trainNumber, className, quota, false);
      if (availabilityResponse.avlDayList && availabilityResponse.avlDayList.length !== 0) {
        return {
          ...state,
          selectedKey,
          railSearchData: newRailSearchData,
        };
      } else {
        return state;
      }

    }

    case ACTION_SET_CONFIRM_OPTIONS: {
      let _railSearchData = [];
      if (!action.data) {
        _railSearchData = state.railSearchData.map((train) => ({
          ...train,
          cnfOptions: {
            loading: false,
            text: null,
          },
        }));
      } else {
        const { confirmedOptionsList } = action.data.data;
        const confirmedOptionsObject = confirmedOptionsList.reduce((acc, item) => ({
          ...acc,
          [item.trainNumber]: {
            confirmedOptionText: item.confirmedOptionText,
          },
        }), {});
        _railSearchData = state.railSearchData.map((train) => {
          if (confirmedOptionsObject[train.trainNumber]) {
            return {
              ...train,
              cnfOptions: {
                loading: false,
                text: confirmedOptionsObject[train.trainNumber].confirmedOptionText,
              },
            };
          }
          return {
            ...train,
            cnfOptions: {
              loading: false,
              text: null,
            },
          };
        });
      }
      return {
        ...state,
        railSearchData: _railSearchData,
      };
    }

    case ACTION_FETCH_ALTERNATE_AVAILIBILITY: {
      const { alternateAvailabilityResponse } = action.payload;
      return { ...state, alternateAvailabilityResponse };
    }

    case APPLY_FILTER: {
      const { filter, filters } = action.payload;
      let arr = state.activefillter[filters.id]
      if (arr.includes(filter)) {
        arr = arr.filter((el) => el !== filter)
      }
      else {
        arr.push(filter)
      }
      return {
        ...state,
        activefillter: {
          ...state.activefillter,
          [filters.id]: arr
        },
        filterObject: {
          ...state.filterObject,
          [filters.id]: {
            ...state.filterObject[filters.id],
            filterTypes: {
              ...state.filterObject[filters.id]["filterTypes"],
              [filter]: {
                ...state.filterObject[filters.id]["filterTypes"][filter],
                selected: !state.filterObject[filters.id]["filterTypes"][filter].selected
              }
            }
          }
        }
      }
    }

    case ACTION_CLEAR_ALL_FILTERS_ON_LISTING_PAGE: {
      return {
        ...state,
        activefillter:  cloneDeep(initActiveFilter),
        filterObject: state.initFilterObject
      }
    }

    case DEFAULT_SORT_SELECTED: {
      return{
        ...state,
        railSearchData:state.defaultRailSearchData,
        selectedSortField: action.payload
      }
    }

    case CONFIRMATION_PROBABILITY: {
      const { confirmationGuaranteeWidget, trainBtwnStnsList, railofyPokus, updatedTicketTypeFilter } = action.payload;
      const { railSearchData } = state;
      if (trainBtwnStnsList && trainBtwnStnsList.length > 0) {
        const cnfmPrbKeyBy = trainBtwnStnsList.reduce((acc, train) => {
          const tbsAvl = train.tbsAvailability;
          const tbsAvlKeyBy = tbsAvl.reduce((acc, tbs) => {
              const {quota, className} = tbs;
              if (acc[quota]){
                  acc[quota][className] = tbs;
              } else {
                  acc[quota] = {};
                  acc[quota][className] = tbs;
              }
              return acc;
          }, {});
          acc[train.trainNumber] = {...train, tbsAvlKeyBy};
          return acc;
        }, {});
        const railsWithConfirmationProb = railSearchData.map((train) => {
          const {trainNumber, tbsAvailability} = train;
          const cnfmPrbTbsKeyBy = (cnfmPrbKeyBy[trainNumber] || {}).tbsAvlKeyBy || {};
          const tbsAvlMod = tbsAvailability.map((tbs) => {
              const {quota, className} = tbs;
              const cnfmTbsClassObj = (cnfmPrbTbsKeyBy[quota] || {})[className] || { confirmationGuaranteeText: null, freeCancellationText: null };
              return {...tbs, confirmationGuaranteeText: cnfmTbsClassObj.confirmationGuaranteeText, freeCancellationText: cnfmTbsClassObj.freeCancellationText}
          });
          return {
              ...train,
              tbsAvailability: tbsAvlMod,
          };
        });
        // const { selectedSortField, isAscOrder } = state;
        // const sortedRailData = railsWithConfirmationProb.sort(sortComparators(selectedSortField, isAscOrder));
        return {
          ...state,
          confirmationGuaranteeWidget,
          railSearchData: railsWithConfirmationProb,
          defaultRailSearchData: railsWithConfirmationProb,
          railofyPokus,
          filterObject: {
            ...state.filterObject,
            ticketTypeFilter: updatedTicketTypeFilter
          },
          initFilterObject:{
            ...state.initFilterObject,
            ticketTypeFilter: updatedTicketTypeFilter
          },
        };
      }
      return { ...state };
    }
    case CONFIRMED_OPTIONS_AS_ALTERNATE_AVAILABILITY: {
      return {
        ...state,
        confirmedOptionsOfRails : action.data
      }
    }

    default:
      return state;
  }
};

const changeTBSAvailability = (railSearchData, tbsAvailability, trainNumber, className, quota, update = true) => {
  const train = railSearchData.find((item) => item.trainNumber === trainNumber);
  let updatedTbsAvailability = null;
  if (update) {
    updatedTbsAvailability = train.tbsAvailability.map((item) =>
      item.className === className && item.quota === quota ? { ...item, ...tbsAvailability } : item);
  }
  else {
    updatedTbsAvailability = train.tbsAvailability.map((item) =>
      item.className === className && item.quota === quota ? tbsAvailability : item);
  }
  const updatedTrain = { ...train, tbsAvailability: updatedTbsAvailability };
  const newRailSearchData = railSearchData.map((item) =>
    updatedTrain.trainNumber === item.trainNumber ? updatedTrain : item);
  return newRailSearchData;
};